import User from "@/auth/User.ts";
import {http} from "@/api/HttpClient.ts";
import {AccessibleCampaign} from "@/auth/User.ts";

export async function getUserInfo(signal?: AbortSignal): Promise<User> {
    const res = await http.get<User>('/me', {signal})
    return res.data;
}

export async function getMyCampaigns(signal?: AbortSignal): Promise<AccessibleCampaign[]> {
    const res = await http.get<AccessibleCampaign[]>('/me/campaigns', {signal});
    return res.data;
}

export async function getMyCampaignBySlug(slug: string): Promise<AccessibleCampaign> {
    const res = await http.get<AccessibleCampaign>(`/me/campaigns/${encodeURIComponent(slug)}`);
    return res.data;
}
